mutation signUpUser($input: SignUpUserInput!) {
  signUpUser(input: $input) {
    status
    errorCode
    message
  }
}
